const EntityName = {
  PAGE: "pages",
  CHANNEL: "channels",
  SCHEDULE: "schedules",
  STATION_CATEGORY: "stationCategories",
  SHOW: "shows",
  SEASON: "seasons",
  CAROUSEL: "carousels",
  CONTENT: "contents",
  BANNER: "banner"
};
const PROVIDER = {
  VRIO: "Vrio",
  THINK_ANALYTICS: "ThinkAnalytics"
};
const SectionId = {
  MOST_WATCHED: "MOST_WATCHED"
};
const Source = {
  Orbis: 1
};
const ContentSourceType = {
  Live: 1,
  Vod: 2
};
const MyListAssetType = {
  MOVIE: "MOVIE",
  SERIE: "SERIE"
};
const CarouselType = {
  CHANNELS: "live-channels",
  COLLECTIONS: "banners-collection",
  CONTINUE_WATCHING: "continue-watching",
  HERO_NOW_NEXT: "hero-now-next",
  HIGHLIGHTS: "highlights",
  LANDSCAPE: "carousel-landscape",
  LIVE_AUTOMATIC: "live-automatic",
  LIVE_EDITORIAL: "live-editorial",
  LIVE_HERO_AUTOMATIC: "live-hero-automatic",
  LIVE_HERO_EDITORIAL: "live-hero-editorial",
  MOST_WATCHED: "most-watched",
  MY_LIST: "my-list",
  NOW_NEXT: "now-next",
  PORTRAIT: "carousel-portrait",
  RECENTLY_WATCHED: "recently-watched",
  TA_HERO: "ta-hero",
  TA_LIVE: "ta-live",
  TA_VOD: "ta-vod",
  IMAGE_BANNER: "image-banner",
  SPORT_STANDING_PLAYOFF: "sports-standings-playoff",
  SPORT_STANDING_GROUP: "sports-standings-groups",
  SPORT_STANDING_GROUP_DYNAMIC: "sports-standings-groups-dynamic",
  SPORT_RESULTS: "sports-results",
  SPORT_RESULTS_DYNAMIC: "sports-results-dynamic",
  SPORT_PLAYERS: "sports-players",
  SPORT_PLAYERS_DYNAMIC: "sports-players-dynamic",
  SPORT_TEAM_FORMATION: "sports-team-formation",
  SPORT_HIGHLIGHTS: "sports-highlights",
  SPORT_GAME_STATISTICS: "sports-game-statistics",
  SPORT_LIVE_DYNAMIC: "sports-live-dynamic",
  SPORT_VOD_BANNER_DYNAMIC: "sports-vod-banner-dynamic",
  SPORT_VOD_PORTRAIT_DYNAMIC: "sports-vod-portrait-dynamic"
};

export { CarouselType, ContentSourceType, EntityName, MyListAssetType, PROVIDER, SectionId, Source };
//# sourceMappingURL=constants.js.map
